var _ellipse, _ellipse2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationForum = function SvgIllustrationForum(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94 93",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.1,
    cy: 65.6,
    fill: "var(--secondary-fill)",
    rx: 14.4,
    ry: 14.5,
    transform: "rotate(-90 64 65.6)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.8,
    cy: 27.8,
    fill: "var(--secondary-fill)",
    rx: 14.4,
    ry: 14.5,
    transform: "rotate(-90 29.8 27.8)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--secondary-fill)",
    d: "m69.963 31.94 1.165-9.63 9.73 1.16-1.164 9.63zM13 71.686l2.15-9.46 9.568 2.122-2.15 9.459z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M47.782 24.962c-12.723 0-23.073 10.051-23.073 22.406s10.35 22.406 23.073 22.406 23.074-10.051 23.074-22.406-10.35-22.406-23.074-22.406"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-white)",
    d: "M43.416 53.35a.98.98 0 0 1-.718-.287.96.96 0 0 1-.29-.71V50.36h13.1v-8.973h2.016a.98.98 0 0 1 .718.287.96.96 0 0 1 .29.71V54.92q0 .674-.617.935-.618.262-1.096-.212l-2.318-2.293zm-1.008-4.985-2.317 2.293q-.48.474-1.096.212-.618-.261-.618-.935v-11.54a.96.96 0 0 1 .29-.71.98.98 0 0 1 .718-.287h13.1a.98.98 0 0 1 .719.287.96.96 0 0 1 .29.71v8.973a.96.96 0 0 1-.29.71.98.98 0 0 1-.718.287z"
  })));
};
export default SvgIllustrationForum;